import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAccountBalanceAvailable } from './useCheckIsAccountBalanceAvailable';
import {
  getIsFrenchFreeBetEnabled,
  getUseBonusBalance
} from 'store/selectors/betslip';
import { getUser } from 'store/selectors/user-data';

export function useBalance(): number {
  const user = useSelector(getUser);
  const useBonusBalance = useSelector(getUseBonusBalance);
  const accountBalanceAvailable = useAccountBalanceAvailable();
  const isFrenchFreeBetEnabled = useSelector(getIsFrenchFreeBetEnabled);

  return useMemo(() => {
    let balance = +user.balance;

    if (
      accountBalanceAvailable &&
      useBonusBalance &&
      (user?.bonus_balance ?? 0) >= 0
    ) {
      const winBalance = user?.bonus_win_balance ? user?.bonus_win_balance : 0;

      const bonusBalance = user?.bonus_balance ? user?.bonus_balance : 0;
      const frozenBalance = user?.frozen_balance ? user?.frozen_balance : 0;
      balance = winBalance + bonusBalance + frozenBalance;
    }

    if (user.bonus_money && isFrenchFreeBetEnabled) {
      balance = user.bonus_money;
    }

    balance = balance || +user.balance;

    return balance;
  }, [useBonusBalance, user, accountBalanceAvailable, isFrenchFreeBetEnabled]);
}
